interface PhoneMockupProps {
  height?: number
  children: React.ReactNode
}

const PHONE_ASPECT_RATIO = 9 / 19.5

export function PhoneMockup({ height = 600, children }: PhoneMockupProps) {
  const screenHeight = height
  const screenWidth = Math.round(screenHeight * PHONE_ASPECT_RATIO)
  const frameWidth = screenWidth + 24
  const frameRadius = Math.round(40 * (height / 600))
  const screenRadius = Math.round(32 * (height / 600))
  const notchWidth = Math.round(120 * (height / 600))
  const notchHeight = Math.round(30 * (height / 600))

  return (
    <div
      className="bg-black mx-auto p-3"
      style={{
        width: `${frameWidth}px`,
        borderRadius: `${frameRadius}px`,
      }}
    >
      <div
        className="relative bg-black overflow-hidden"
        style={{
          height: `${screenHeight}px`,
          width: `${screenWidth}px`,
          borderRadius: `${screenRadius}px`,
        }}
      >
        <div
          className="absolute top-0 left-1/2 -translate-x-1/2 bg-black rounded-b-2xl z-10"
          style={{
            width: `${notchWidth}px`,
            height: `${notchHeight}px`,
          }}
        />

        <div className="w-full h-full overflow-hidden">{children}</div>
      </div>
    </div>
  )
}
